module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('h3', {
    staticClass: "bg-faded mt-3 pt-3 pb-3 "
  }, [_vm._v("导出Excel-markdown")]), _vm._v(" "), _c('h6', [_vm._v("一、需要安装三个依赖："), _c('code', [_vm._v("file-saver")]), _vm._v(" "), _c('code', [_vm._v("xlsx")]), _vm._v(" "), _c('code', [_vm._v("script-loader")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-3 pl-3"
  }, [_vm._v("\n        1.\n        "), _c('kbd', [_vm._v("\n            npm install -S file-saver xlsx\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-3 pl-3"
  }, [_vm._v("\n        2.\n        "), _c('kbd', [_vm._v("npm install -D script-loader")])]), _vm._v(" "), _c('h6', [_vm._v("二、项目中新建一个文件夹：（exportExcel---名字任取）")]), _vm._v(" "), _c('p', {
    staticClass: "mt-3 pl-3"
  }, [_vm._v("放入文件Blob.js和 Export2Excel.js（百度下载）")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/blog/1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('h6', [_vm._v("三、修改路径")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/blog/20170624-0.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "pb-5 pt-3"
  }, [_vm._v("四、参见源码  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24d6ff40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blog/exportExcel.vue
// module id = 597
// module chunks = 2